import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin } from 'lucide-react';
import { cities } from '../data/mock';
import { Card, CardContent } from '../components/ui/card';

const CitiesSection = () => (
  <section className="py-10 bg-gradient-to-b from-black to-zinc-950">
    <div className="container mx-auto px-4">
      <div className="text-center mb-8">
        <h2 className="text-2xl md:text-4xl font-bold mb-3 bg-gradient-to-r from-amber-200 via-amber-400 to-amber-200 bg-clip-text text-transparent">
          Marabout Sérieux dans Toute la France
        </h2>
        <p className="text-base md:text-lg text-amber-100/70">Intervention dans plus de 23 grandes villes françaises</p>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4 max-w-6xl mx-auto">
        {cities.map((city) => (
          <Link key={city.id} to={`/${city.slug}`}>
            <Card className="bg-gradient-to-br from-zinc-900 to-black border-amber-600/30 hover:border-amber-500/60 transition-all duration-300 transform hover:scale-105 hover:shadow-xl hover:shadow-amber-500/20 group">
              <CardContent className="p-3 md:p-4">
                <div className="flex items-center gap-2 mb-2">
                  <div className="w-8 h-8 bg-gradient-to-br from-red-600 to-red-800 rounded-full flex items-center justify-center">
                    <MapPin size={20} className="text-white" />
                  </div>
                  <h3 className="text-lg md:text-2xl font-bold text-amber-400 group-hover:text-amber-300 transition-colors">
                    {city.name}
                  </h3>
                </div>
                <p className="text-amber-100/60 text-xs md:text-sm mb-3">Marabout Voyant Médium</p>
                <div className="flex flex-wrap gap-2">
                  {city.surroundingCities.slice(0, 3).map((surroundingCity) => (
                    <span
                      key={surroundingCity}
                      className="text-xs px-2 py-1 bg-amber-500/10 border border-amber-500/30 rounded text-amber-200"
                    >
                      {surroundingCity}
                    </span>
                  ))}
                  {city.surroundingCities.length > 3 && (
                    <span className="text-xs px-2 py-1 text-amber-400">
                      +{city.surroundingCities.length - 3} villes
                    </span>
                  )}
                </div>
              </CardContent>
            </Card>
          </Link>
        ))}
      </div>
    </div>
  </section>
);

export default CitiesSection;
